import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import Label from './common/label';

const Xid = ({ labels, errors, touched }) => {
  return (
    <>
      <Label labelName={labels.XID_TID} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.xid && touched.xid ? 'error' : ''
        }`}
      >
        <Field
          placeholder={labels.PLACEHOLDER_XID_TID}
          name="xid"
          className="select-style"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.xid}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

Xid.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default Xid;
